// Build Timestamp: 2026-05-15T13:10:00Z
import React from 'react';
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Arm the back-guard BEFORE React mounts. PaymentMode attaches its popstate/hashchange
// handler only after the bundle mounts (~hundreds of ms on a fresh load, longer on slow
// networks / the auto-reload loop). Without this, a Back press during that window escapes
// to the previous history entry — the payment gateway (Cashfree) page. Pushing the
// "#/transaction-active" hash here makes the first Back a same-document hash pop that stays
// on the plugin, so the user can never be sent back to the PG page. PaymentMode's effect
// sees the hash already set and won't double-push; its handler takes over once mounted.
try {
  if (
    window.location.pathname.indexOf("/plugin") !== -1 &&
    window.location.hash !== "#/transaction-active"
  ) {
    var cleanUrl = window.location.pathname + window.location.search;
    // "Launder" the current history entry first. When the plugin page is reached via a
    // cross-origin redirect (e.g. Cashfree returnURL -> sandbox/plugin -> 301 -> uat/plugin),
    // the browser marks this entry a "redirect result" and SKIPS it on Back — jumping to the
    // pre-redirect page (the payment gateway), which is why Back lands on Cashfree. A same-URL
    // replaceState rewrites the entry in place, which can clear that redirect-result status.
    window.history.replaceState(null, "", cleanUrl);
    // Then push a real buffer entry. IMPORTANT: pushState, NOT `window.location.hash = ...`.
    // Setting the hash synchronously during initial load REPLACES the current entry instead
    // of pushing, leaving no buffer — so the first Back escapes cross-document to the gateway.
    // pushState always adds a real entry, so the first Back is a same-document pop our
    // popstate handler can intercept.
    // NOTE: the definitive fix is server-side — keep the sms/pay redirect AND the Cashfree
    // returnURL on the SAME origin the plugin is served from (no sandbox<->uat 301). See memory.
    window.history.pushState(null, "", cleanUrl + "#/transaction-active");
  }
} catch (e) {
  /* history not available — non-fatal */
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
